<template>
  <el-drawer title="编辑" :visible.sync="drawer" size="40%" :before-close="handleClose">
    <div class="m-tabs-content">
      <el-form :model="editForm" :rules="rules" ref="editForm" label-width="135px">
        <el-form-item label="名称" prop="coupon_code_name">
          <el-input v-model="editForm.coupon_code_name" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="coupon_code_type">
          <el-radio-group v-model="editForm.coupon_code_type" size="mini">
            <el-radio label="currency" border>通用券</el-radio>
            <el-radio label="single_item" border>单品券</el-radio>
            <el-radio label="voucher" border>活动券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="editForm.coupon_code_type === 'single_item'" label="产品" prop="products">
          <el-select v-model="editForm.products" multiple placeholder="请选择" size="mini">
            <el-option v-for="(item, index) in goods" :key="index" :label="item.item_name" :value="item.item_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="折扣类型" prop="type">
          <el-radio-group v-model="editForm.type" size="mini">
            <el-radio label="fixed" border>固定金额</el-radio>
            <el-radio label="percent" border>折扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="editForm.type === 'fixed' ? '面值' : '折扣'" prop="value">
          <el-input v-model.number="editForm.value" size="mini">
            <template slot="append">{{ editForm.type === 'fixed' ? '元' : '%' }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="总量" prop="total">
          <el-input v-model.number="editForm.total" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="使用条件 订单满" prop="min_amount">
          <el-input v-model.number="editForm.min_amount" size="mini">
            <template slot="append">元可使用</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="limited_time">
          <el-date-picker v-model="editForm.limited_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="mini"></el-date-picker>
        </el-form-item>
        <el-form-item label="发布平台" prop="publish_platform">
          <el-select v-model="editForm.publish_platform" placeholder="请选择" size="mini">
            <el-option label="微信小程序" :value="2"></el-option>
            <el-option label="支付宝小程序" :value="3"></el-option>
            <el-option label="支付宝广告" :value="4"></el-option>
            <el-option label="全平台" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否启用" prop="enabled">
          <el-radio-group v-model="editForm.enabled" size="mini">
            <el-radio :label="0" border>否</el-radio>
            <el-radio :label="1" border>是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="tr">
          <el-button @click="handelClearForm('editForm')" size="mini">重置</el-button>
          <el-button type="primary" @click="handelSubForm('editForm')" size="mini">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'CouponCodeEdit',
  inject: ['fetchData'],
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    editForm: {
      type: Object,
      default: () => {
        return {
          id: '',
          coupon_code_name: '',
          publish_platform: '',
          coupon_code_type: 'currency',
          products: [],
          type: 'fixed',
          value: '',
          total: '',
          min_amount: '',
          limited_time: '',
          enabled: 0
        }
      }
    },
    goods: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
  },
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      rules: {
        coupon_code_name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' },
        ],
        value: [
          { required: true, message: '请输入折扣额', trigger: 'blur' },
          { type: 'number', message: '折扣额必须为数字值', trigger: 'blur' },
        ],
        total: [
          { required: true, message: '请输入总量', trigger: 'blur' },
          { type: 'number', message: '总量必须为数字值', trigger: 'blur' },
        ],
        min_amount: [
          { validator: this.validateNumber, trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
  },
  watch: {
    goods: {
      immediate: true,
      handler (newGoods) {
        console.log('Updated goods:', newGoods)
      }
    }
  },
  methods: {
    validateNumber (rule, value, callback) {
      if (value === '' || value === null) {
        callback();
      } else if (isNaN(value)) {
        callback(new Error('优惠券使用最低金额必须为数字值'));
      } else {
        callback()
      }
    },
    handelClearForm (formName) {
      this.$refs[formName].resetFields()
    },
    handelSubForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editForm.coupon_code_type === 'single_item' && this.editForm.products.length === 0) {
            this.$message.error('请选择产品')
            return;
          }

          if (this.editForm.type === 'fixed' && (this.editForm.value > this.editForm.min_amount)) {
            this.$message.error('固定金额类型优惠券，折扣额不能大于最低使用金额')
            return
          }

          if (this.editForm.type === 'percent' && (this.editForm.value > 99 || this.editForm.value === 0)) {
            this.$message.error('折扣类型优惠券，折扣额度只能在1～99%之间')
            return
          }

          this.$axios.post('/api/admin/coupon_code/up', this.editForm, { loadingClose: true })
              .then((res) => {
                const { data } = res
                if (data.code === 0) {
                  this.fetchData()
                  this.handleClose()
                  this.$message.success(data.msg)
                }
              })
        }
      })
    },
    handleClose () {
      this.$emit('handleClose', false)
    }
  },
  mounted () {
  }
}
</script>

<style lang="stylus" scoped>
.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner, .el-select {
  width 100%;
}
.el-form-item__content .el-input-group {
  vertical-align: middle;
}
.tr {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon_codes/common/CouponCodeEdit.vue